export const NGO_TIMELINE = [
  {
    year: "2014",
    text: "निस्वार्थ प्रयास की स्थापना — फर्रुखाबाद, उ.प्र.",
  },
  {
    year: "2016",
    text: "मुफ्त कोचिंग कार्यक्रम की शुरुआत",
  },
  {
    year: "2019",
    text: "बाढ़ प्रभावित क्षेत्रों में राहत अभियान",
  },
  {
    year: "2022",
    text: "महिला सशक्तिकरण और ग्रामीण विकास परियोजनाएं",
  },
  {
    year: "2024",
    text: "सामुदायिक मेला और कपड़े वितरण अभियान का विस्तार",
  },
  {
    year: "2025",
    text: "कानपुर और आसपास के क्षेत्रों में सेवा विस्तार",
  },
  {
    year: "2026",
    text: "शिक्षा, राहत और सशक्तिकरण — निरंतर सामाजिक प्रयास",
  },
  {
    year: "आज",
    text: "500+ परिवारों तक सहायता — और आगे बढ़ते",
    highlight: true,
  },
];
